import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Background from './components/Background';
import Contact from './components/Contact';
import './index.css';

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    audioRef.current.play().then(() => {
      setIsPlaying(true);
    }).catch(() => {
      setIsPlaying(false);
    });
  }, []);

  const toggleAudio = () => {
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play().then(() => {
        setIsPlaying(true);
      }).catch(() => {
        setIsPlaying(false);
      });
    }
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  return (
    <div className="app-container">
      <Router>
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </div>
      </Router>
      <div className="separator"></div>

      <Background />

      <button className="audio-button" onClick={toggleAudio}>
        {isPlaying ? "Stop Music" : "Play Music"}
      </button>
      <button className="contact-button" onClick={togglePopup}>
        Contact
      </button>

      {isPopupOpen && <Contact isOpen={isPopupOpen} onClose={togglePopup} />}
      <audio ref={audioRef} src="/campfire.mp3" loop />
    </div>
  );
}

export default App;
